import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Video } from "../types";

interface VideoPlaybackModalProps {
  show: boolean;
  onClose: () => void;
  video: Video | null;
  streamUrl: string;
  isLoading: boolean;
}

const VideoPlaybackModal: React.FC<VideoPlaybackModalProps> = ({
  show,
  onClose,
  video,
  streamUrl,
  isLoading,
}) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black bg-opacity-90 transition-opacity duration-300">
      <div className="relative w-full max-w-5xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl ring-1 ring-white/10">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-[110] p-2 bg-black/50 hover:bg-black/80 text-white rounded-full transition-all duration-200 hover:scale-110 focus:outline-none focus:ring-2 focus:ring-white/50"
          title="ປິດ"
        >
          <XMarkIcon className="h-6 w-6" />
        </button>

        {isLoading ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center space-y-4">
            <div className="w-12 h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
            <p className="text-white text-sm animate-pulse">
              ກຳລັງໂຫລດວິດີໂອ...
            </p>
          </div>
        ) : streamUrl ? (
          <video
            autoPlay
            controls
            className="w-full h-full object-contain"
            controlsList="nodownload"
            src={streamUrl}
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-white text-lg">
            ບໍ່ສາມາດໂຫລດວິດີໂອໄດ້
          </div>
        )}

        {/* Video Title Overlay (Visible on Hover) */}
        <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <h3 className="text-white text-xl font-bold">{video?.title}</h3>
          <p className="text-gray-300 text-sm mt-1 line-clamp-1">
            {video?.description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default VideoPlaybackModal;
